const baseURLFront = 'https://kranmar.com.pl';
// const baseURLFront = 'http://localhost:3000';

export default baseURLFront